// extracted by mini-css-extract-plugin
module.exports = {"setupLicense":"SetupLicense_setupLicense__2Urg2","contentHeader":"SetupLicense_contentHeader__3ID-_"};